<template lang='pug'>
span
  VJsoneditor(
    :key='key'
    ref='jsonEditor'
    v-model='jsonData'
    height='300px',
    :options='options',
    :plus='false')
</template>

<script>
import VJsoneditor from 'v-jsoneditor'
export default {
  props: {
    body: {
      type: Object,
      default: () => ({})
    },
    bodyParameters: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VJsoneditor
  },
  watch: {
    bodyParameters: {
      deep: true,
      handler () {
        // console.log(this.body, this.bodyParameters)
        let initialJSON = JSON.stringify(JSON.parse(this.body), null, 2)
        for (let key in this.bodyParameters) {
          initialJSON = initialJSON.replace(
            `%{${key}}`,
            this.bodyParameters[key]
          )
        }
        this.$refs.jsonEditor.editor.setText(initialJSON)
      }
    }
  },
  data () {
    return {
      key: 0,
      jsonData: {},
      jsonTest: '',
      options: {
        mode: 'code',
        modes: ['code', 'tree'],
        onEditable: function (node) {
          // node is an object like:
          //   {
          //     field: 'FIELD',
          //     value: 'VALUE',
          //     path: ['PATH', 'TO', 'NODE']
          //   }
          return false
        },
        onChangeText: this.onChangeText
      }
    }
  },
  mounted () {
    let initialJSON = JSON.stringify(JSON.parse(this.body), null, 2)
    for (let key in this.bodyParameters) {
      initialJSON = initialJSON.replace(`%{${key}}`, this.bodyParameters[key])
    }
    this.$refs.jsonEditor.editor.setText(initialJSON)
  },
  methods: {
    onChangeText () {
      this.jsonTest = this.$refs.jsonEditor.editor.getText()
      // console.log(this.jsonTest)
    }
  }
}
</script>

<style>
.jsoneditor {
  border: thin solid rgba(67, 160, 72, 0);
}
.jsoneditor-menu {
  background-color: rgb(67, 160, 71);
  border-bottom: 1px solid rgb(67, 160, 71);
}
.jsoneditor-menu a.jsoneditor-poweredBy {
  display: none;
}
</style>
